import { render } from "./PrintInvoiceContactDetailsDesign1.vue?vue&type=template&id=6ad9dc62&scoped=true"
import script from "./PrintInvoiceContactDetailsDesign1.vue?vue&type=script&lang=js"
export * from "./PrintInvoiceContactDetailsDesign1.vue?vue&type=script&lang=js"

import "./PrintInvoiceContactDetailsDesign1.vue?vue&type=style&index=0&id=6ad9dc62&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad9dc62"]])

export default __exports__